/** Link guardado na tarefa (só endereço e nome; o arquivo fica onde está). */
export interface TaskLink { url: string; title: string }
export type LinkKind = 'sharepoint' | 'onedrive' | 'teams' | 'web';

/** Aceita só http(s) (nada de javascript: e afins); devolve o endereço normalizado ou null. */
export function parseLinkUrl(raw: string): string | null {
  const v = raw.trim();
  if (!v || /\s/.test(v) || v.length > 2000) return null;
  try {
    const u = new URL(/^[a-z][a-z0-9+.-]*:/i.test(v) ? v : `https://${v}`);
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return null;
    if (!u.hostname.includes('.') && u.hostname !== 'localhost') return null;
    return u.href;
  } catch { return null; }
}

/** De onde é o link (para o ícone) e um nome sugerido: o arquivo ou pasta do caminho, ou o site. */
export function linkInfo(url: string): { kind: LinkKind; title: string; host: string } {
  let u: URL;
  try { u = new URL(url); } catch { return { kind: 'web', title: url, host: '' }; }
  const host = u.hostname.replace(/^www\./, '');
  const kind: LinkKind = /(^|\.)sharepoint\.com$/.test(host) ? (/-my\.sharepoint\.com$/.test(host) ? 'onedrive' : 'sharepoint')
    : /(^|\.)(onedrive\.live\.com|1drv\.ms)$/.test(host) ? 'onedrive'
    : /(^|\.)teams\.(microsoft|live)\.com$/.test(host) ? 'teams' : 'web';
  // Links de compartilhamento do SharePoint (/:x:/r/sites/.../Arquivo.xlsx) e caminhos comuns: o último trecho legível.
  const parts = u.pathname.split('/').filter(p => p && !/^:[a-z]:$/i.test(p) && p !== 'r' && p !== 'Forms' && !/^AllItems\.aspx$/i.test(p));
  const idParam = u.searchParams.get('id');
  const fromId = idParam ? idParam.split('/').filter(Boolean).pop() : undefined;
  let last = fromId ?? parts.at(-1) ?? '';
  try { last = decodeURIComponent(last); } catch { /* deixa como veio */ }
  const readable = last && !/^[A-Za-z0-9_-]{20,}$/.test(last) && !/\.aspx$/i.test(last) ? last.replace(/[+_]/g, ' ').trim() : '';
  const title = kind === 'teams' ? (readable && !/^l$|^channel$|^message$/i.test(readable) ? `Teams: ${readable}` : 'Conversa no Teams')
    : readable || (kind === 'sharepoint' ? 'Arquivo no SharePoint' : kind === 'onedrive' ? 'Arquivo no OneDrive' : host);
  return { kind, title: title.slice(0, 200), host };
}
